import styled from "styled-components";

const List = styled.ul`
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
  width: 400px;
  max-width: 100%;
  padding: 24px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px 0 rgba(34, 41, 57, 0.15);
  background-color: #ffffff;
  z-index: 11;
  transition: visibility 0s ease, 300ms ease, opacity 300ms ease;

  &[data-hidden="false"] {
    visibility: visible;
    opacity: 1;
  }

  &[data-hidden="true"] {
    opacity: 0;
    visibility: hidden;
    transition-delay: 300ms, 0s, 0s;
  }

  /* Mobile version will display up to 10 suggestions */
  li:nth-of-type(1n + 11) {
    display: none;
  }

  @media (max-width: 566px) {
    /* Mobile version will display up to 5 suggestions */
    li:nth-of-type(1n + 6) {
      display: none;
    }
  }
`;

export { List };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/header/AutocompleteStyle.js